import { configureStore } from '@reduxjs/toolkit';
import activityReducer  from '../reducers/activityReducer';
import kpiConfigReducer from '../reducers/kpiConfigReducer';
import kpiDataReducer   from '../reducers/kpiDataReducer';
import filtersReducer   from '../reducers/filtersReducer';

export const store = configureStore({
	reducer: {
		activity:  activityReducer,
		kpiConfig: kpiConfigReducer,
		kpiData:   kpiDataReducer,
		filters:   filtersReducer,
	},
});
